import Header from "./components/header/Header";
import Footer from "./components/footer/Footer";
import Home from "./components/home_page/Home";
import Products from "./components/products/Products";
import PrivacyPolicy from "./components/privacy_policy/PrivacyPolicy";
import Contact from "./components/contact/Contact";
import ErrorPage from "./components/error_page/ErrorPage";
import ProductInfo from "./components/products/product_info/ProductInfo";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";

function App() {
  return (
    <Router>
      <div
        className="App"
        style={{
          minHeight: "100vh",
        }}
      >
        <Header />
        <Switch>
          <Route path="/" exact component={Home} />
          <Route path="/products" exact>
            <Products pageTitle="Show All Products" />
          </Route>
          <Route path="/products/:id" component={ProductInfo} />
          <Route path="/promocodes" exact>
            <Products category={"PROMO_CODES"} pageTitle="Promo Codes" />
          </Route>
          <Route path="/hotdeals" exact>
            <Products category={"HOT_DEALS"} pageTitle="Hot Deals" />
          </Route>
          <Route path="/privacypolicy" exact component={PrivacyPolicy} />
          <Route path="/contact" exact component={Contact} />
          <Route path="/404" exact component={ErrorPage} />
          <Redirect to="/404" />
        </Switch>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
